import React, { useState } from 'react';

import './switchButtons.scss';

interface ISwitchButtons {
  buttons: string[];
  onClick: (id: number) => void;
}

const SwitchButtons:React.FC<ISwitchButtons> = ({buttons, onClick}) => {
  const [btnId, setBtnId] = useState(0);
  return (
    buttons.length > 1 && <div className='switch-btns-wrapper'>
      {buttons.map((button, id) => {
        return <div key={id} onClick={() => {
          setBtnId(id);
          onClick(id);
        }} className={`switch-btn ${id === btnId && 'active' }`}>{button}</div>
      })}
    </div>
  );
};

export default SwitchButtons;